import React from 'react';
import { riyalbusinessContent } from '../rich-content/riyalbusiness-complete-content';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';

const RiyalbusinessDetailPage = () => {
  return <AutomaticPageBuilder content={riyalbusinessContent} />;
};

export default RiyalbusinessDetailPage;
